// Mark: Used in V2
import React from "react"

type Props = {
  className?: string
}

const CircleCrossIcon = ({ className }: Props) => {
  return (
    <svg
      width={27}
      height={27}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="m9.76 9.01 7.98 7.98M9.76 16.99l7.98-7.98" />
      <rect width={21} height={21} x={3.25} y={2.5} rx={10.5} />
    </svg>
  )
}

export default CircleCrossIcon
